<template>
  <layout-admin current="chat-appointments">
    <div class="panel">
      <div class="panel__head">
        <h1>Appointments</h1>
        <span>{{ appointments.length }}</span>
      </div>

      <div v-if="!appointments.length" class="panel__empty">No appointments yet.</div>

      <div v-else class="table-wrap">
        <table>
          <thead>
            <tr>
              <th>ID</th>
              <th>Starts</th>
              <th>Ends</th>
              <th>Status</th>
              <th>Lead</th>
              <th>Thread</th>
              <th>Preferred text</th>
              <th>Notes</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="appointment in appointments" :key="appointment.id">
              <td>{{ appointment.id }}</td>
              <td>{{ formatDate(appointment.starts_at) }}</td>
              <td>{{ formatDate(appointment.ends_at) }}</td>
              <td><span class="pill">{{ appointment.status || '-' }}</span></td>
              <td>
                <Link
                  v-if="appointment.chat_thread_id"
                  :href="route('admin.chat.threads', appointment.chat_thread_id)"
                  class="link"
                >
                  {{ leadLabel(appointment) }}
                </Link>
                <span v-else>{{ leadLabel(appointment) }}</span>
              </td>
              <td>
                <Link
                  v-if="appointment.chat_thread_id"
                  :href="route('admin.chat.threads', appointment.chat_thread_id)"
                  class="link"
                >
                  #{{ appointment.chat_thread_id }}
                </Link>
                <span v-else>-</span>
              </td>
              <td class="wrap">{{ appointment.preferred_time_text || '-' }}</td>
              <td class="wrap">{{ appointment.notes || '-' }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </layout-admin>
</template>

<script>
import { Link } from '@inertiajs/inertia-vue3';
import LayoutAdmin from '@/Layouts/Admin.vue';

export default {
  components: {
    LayoutAdmin,
    Link
  },

  props: {
    appointments: { type: Array, required: true }
  },

  methods: {
    formatDate(iso) {
      if (!iso) return '-';
      return new Date(iso).toLocaleString(undefined, {
        day: 'numeric',
        month: 'short',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      });
    },

    leadLabel(appointment) {
      if (!appointment.lead) {
        return appointment.chat_lead_id ? ('Lead #' + appointment.chat_lead_id) : '-';
      }

      return appointment.lead.name || appointment.lead.phone || ('Lead #' + appointment.lead.id);
    }
  }
};
</script>
